let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e5igc")).then(() => parcelRequire('6bXRz'));